<template>
  <form class="add-integration-form" @submit.stop.prevent="add">
    <div>
      <yn-text-field v-model="source" :label="'Source'"></yn-text-field>
    </div>
    <div class="form-row token">
      <yn-text-field v-model="token" :label="'Token'"></yn-text-field>
      <yn-button variant="text" type="button" @click.stop.prevent="random">Random</yn-button>
    </div>
    <div>
      <yn-button color="primary" :disabled="!isValid || isAddIntegrationPending">Add</yn-button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';

import TextField from '@/components/common/TextField';
import Button from '@/components/common/Button';
export default {
  components: {
    'yn-text-field': TextField,
    'yn-button': Button
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      source: '',
      token: ''
    };
  },
  computed: {
    ...mapState({
      isAddIntegrationPending: s => s.topics.isAddIntegrationPending
    }),
    isValid() {
      return this.source && this.source.length && this.token && this.token.length;
    }
  },
  methods: {
    random() {
      this.token = Array.from(window.crypto.getRandomValues(new Uint32Array(8)))
        .map(n => n.toString(16))
        .join('');
    },
    async add() {
      if (!this.isValid) {
        return;
      }

      try {
        await this.$store.dispatch('topics/addIntegration', {
          id: this.id,
          source: this.source,
          token: this.token
        });

        this.$toast.success({
          title: 'Update completed',
          message: `Integration '${this.source}' was added to this topic.`
        });

        this.source = '';
        this.token = '';
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-integration-form {
  .form-row {
    &.token {
      display: grid;
      grid-template-columns: minmax(0, 1fr) max-content;
      grid-gap: 1rem;
    }
  }
}
</style>
